"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _createPicker = _interopRequireDefault(require("./createPicker"));
var _wrapPicker = _interopRequireDefault(require("./wrapPicker"));
var _RangePicker = _interopRequireDefault(require("./RangePicker"));
var _WeekPicker = _interopRequireDefault(require("./WeekPicker"));
var _calendar = _interopRequireDefault(require("../rc-components/calendar"));
var _MonthCalendar = _interopRequireDefault(require("../rc-components/calendar/MonthCalendar"));
var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_calendar["default"]));
var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'YYYY-MM');
(0, _extends2["default"])(DatePicker, {
  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"]),
  MonthPicker: MonthPicker,
  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'gggg-wo')
});
var _default = DatePicker;
exports["default"] = _default;